import Edit from './Edit';
import List from './List';
import Show from './Show';

export default {
  name: 'hris_position_mappings',
  list: List,
  show: Show,
  edit: Edit,
  options: {
    label: 'HRIS Position Mappings',
    group: false,
  },
};
